module.exports = __webpack_public_path__ + "img/post2.e75f8a1a.png";